/**
 * @voltxampere/ui — EditParamCommand (Sprint 14)
 *
 * Mutate a single component's `params[fieldKey]`. Pure: same
 * `circuit` in → same shape out, only the targeted component is
 * rewritten via structural share.
 *
 * The inspector debounces input keystrokes (300 ms) before
 * pushing this command — one EditParamCommand per "value the user
 * stopped typing", not one per keystroke. Multi-select edits wrap
 * N EditParamCommands in a `BatchCommand` so a single Cmd+Z
 * reverts the whole row of components.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class EditParamCommand {
    componentId;
    fieldKey;
    oldValue;
    newValue;
    constructor(componentId, fieldKey, oldValue, newValue) {
        this.componentId = componentId;
        this.fieldKey = fieldKey;
        this.oldValue = oldValue;
        this.newValue = newValue;
    }
    do(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => c.id === this.componentId
                ? { ...c, params: { ...c.params, [this.fieldKey]: this.newValue } }
                : c),
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => {
                if (c.id !== this.componentId)
                    return c;
                const nextParams = this.oldValue === undefined
                    ? Object.fromEntries(Object.entries(c.params).filter(([k]) => k !== this.fieldKey))
                    : { ...c.params, [this.fieldKey]: this.oldValue };
                return { ...c, params: nextParams };
            }),
        };
    }
    describe() {
        return `${this.fieldKey} değiştirildi`;
    }
}
//# sourceMappingURL=edit-param.js.map